import config from 'configDir/index';
import { get } from './http';

// 获取userId
const queryUserIdService = get('/login/authorization', config.userServiceUrl);

// 获取通过企业获取用户信息
const getUserByAuthService = get('/login/getUserByAuth', config.userServiceUrl);

//  获取权限码
const queryAuthorityCodeService = get('/authority/user', config.userServiceUrl);
// 查询所有数据字典
const getDataDictionaryService = get('/dictionary/data/treeListFromCache', config.commonServiceUrl);
export {
  queryAuthorityCodeService,
  queryUserIdService,
  getDataDictionaryService,
  getUserByAuthService,
};
